import logger from '@/modules/Logger';

export default {
  async reset() {
    // VB cleanup is best-effort and MUST NOT block the critical teardown below.
    // If disable() rejects and this shared the outer try/catch, track closure,
    // listener removal, and rtc.leave() would be skipped — leaving a stale
    // joined client and open camera/mic devices across join retries.
    try {
      await this.vbProcessor?.disable();
    } catch (e) {
      logger.debug('[Agora] Error disabling VB processor during reset', {
        operation: 'webrtc:reset',
        reason: e.message,
      });
    }
    this.vbPipelined = false;

    try {
      // Cancel any pending reconnect-recovery poll so no timer or state change
      // fires after teardown.
      logger.info('[Agora][RecoveryPoll] reset() — cancelling any pending recovery poll on teardown', { operation: 'webrtc:connection', lesson_id: this.lessonId });
      this.stopReconnectRecoveryPoll?.();
      this.localVideoTrack?.close();
      this.localAudioTrack?.close();
      this.rtc.localTracks.map(track => { track.close() });
      this.rtc.removeAllListeners();
      await this.rtc.leave();
    } catch (e) {
      logger.debug('[Agora] Error during reset', {
        operation: 'webrtc:reset',
        reason: e.message,
      });
    }
    this.localTracks = [];
    this.localAudioTrack = null;
    this.localVideoTrack = null;
  }
}
